import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface DataService {
  get<T>(endpoint: string): Observable<T>;
  post<T, P = any>(endpoint: string, payload: P): Observable<T>;
  put<T, P = any>(endpoint: string, payload: P): Observable<T>;
  patch<T, P = any>(endpoint: string, payload: P): Observable<T>;
  delete<T = void>(endpoint: string): Observable<T>;
}

export const DATA_SERVICE = new InjectionToken<DataService>('DataService');
